<template>
  <v-card>
    <v-card-title class="headline lighten-2 border-bottom mb-4">
      View Details
      <div class="spacer"></div>
    </v-card-title>
    <v-card-text>
      <div>
        <p class="capitalize-text"><b>Roles</b> : Patient</p>
        <!-- <p><b>Period</b> : 1 Month</p> -->
        <p>
          <b>Amount</b> :
          {{
            CampaignsDetails && CampaignsDetails.total_amount
              ? CampaignsDetails.total_amount
              : 0
          }}
        </p>
      </div>
      <div v-if="CampaignsDetails" class="table-div overflow-auto">
        <table class="table userlistTable">
          <thead>
            <tr class="table-success">
              <th>SR No.</th>
              <th>Name</th>
              <th>Mobile Number</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(campaignMember, index) in CampaignsMembers"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td class="text-capitalize">
                {{ campaignMember.first_name + " " + campaignMember.last_name }}
              </td>
              <td class="text-capitalize">{{ campaignMember.mobile_no }}</td>
              <td>
                <v-switch
                  :input-value="!campaignMember.is_deleted"
                  :value="!campaignMember.is_deleted"
                  :disabled="campaignMember.is_redeem"
                  hide-details
                  class="mt-2"
                  color="success"
                  @change="toggleCampaignMembers(campaignMember._id)"
                ></v-switch>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          class="mx-6"
          :currentPage="currentPage"
          :recordPerPage="recordPerPage"
          :total="total"
          @changePage="changePage"
        />
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
// import dayjs from "dayjs";
import { bus } from "@/main.js";
import Config from "@/config.js";
// import formats from "@/formats.js";
export default {
  data() {
    return {
      currentPage: 1,
      record_per_page: 10,
      CampaignsDetails: {},
      CampaignsMembers: [],
      campaignId: null,
      isEmpty: 0,
      totalPage: 1,
      isEmpty: true,
      recordPerPage: 10,
      total: 0,
    };
  },
  components: {
    pagination: () => import("@/views/common/Pagination"),
  },
  created() {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        disabled: false,
        to: "/dashboard",
      },
      {
        text: "Enrolled Organizations",
        disabled: false,
        to: "/enrolled-organizations",
      },
       {
        text: "View Campaign Detail",
        disabled: false,
        to: "/enrolled-viewdetails",
      },
    ]);
  },
  mounted() {
    this.CampaignsDetails = this.$route.params.campaign_details;
    this.campaignId =
      this.CampaignsDetails && this.CampaignsDetails._id
        ? this.CampaignsDetails._id
        : null;
  },
  watch: {
    campaignId(newValue) {
      if (newValue) {
        this.getCampaignMembersList();
      }
    },
  },
  methods: {
    getCampaignMembersList() {
      if (!this.campaignId) return;
      const params = {
        page: this.currentPage,
        records_per_page: this.record_per_page,
      };
      this.$http
        .get(
          `${Config.BASE_URL}api/v2/admin/campaign-members/${this.campaignId}`,
          { params }
        )
        .then(
          (response) => {
            this.CampaignsMembers = response.data.data.list;
            this.isEmpty = false;
            this.totalPage = response.body.data.count / this.recordPerPage;
            if (response.body.data.count % this.recordPerPage !== 0)
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.count;
          },
          (err) => {
            console.log(err);
          }
        );
    },
    toggleCampaignMembers(id) {
      if (!id) {
        return;
      }
      this.$http
        .put(
          `${Config.BASE_URL}api/v2/admin/campaign-member-active-toggle/${id}`
        )
        .then(
          (response) => {},
          (err) => {
            console.log(err);
          }
        );
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getCampaignMembersList();
    },
  },
};
</script>